// extracted by mini-css-extract-plugin
export default {"personItem":"PersonItem_personItem__OXay4","posterImg":"PersonItem_posterImg__SUX18","actorName":"PersonItem_actorName__OLt+I","name":"PersonItem_name__FOnQV"};